import { framesListAPI } from "@/views/Frames/List/api";

export const getFramesList = async (resident_id) => {
  try {
    const res = await framesListAPI.getList(resident_id);
    return res?.data;
  } catch (e) {}
};
export const getResidencyOptions = async () => {
  try {
    const res = await framesListAPI.getResidents();
    return res?.data;
  } catch (e) {}
};
export const getFrameParams = async (frame_id) => {
  try {
    const res = await framesListAPI.getFrameParams(frame_id);
    return res?.data;
  } catch (e) {}
};
export const updateFrame = async (body) => {
  try {
    const res = await framesListAPI.updateFrame(body);
    return res?.data;
  } catch (e) {}
};
export const deleteFrame = async (frame_id) => {
  try {
    const res = await framesListAPI.deleteFrame(frame_id);
    return res?.data;
  } catch (e) {}
};
export const updateFrameParams = async (body) => {
  try {
    const res = await framesListAPI.updateFrameParams(body);
    return res?.data;
  } catch (e) {}
};
export const deleteFrameParam = async (frame_param_id) => {
  try {
    const res = await framesListAPI.deleteFrameParam(frame_param_id);
    return res?.data;
  } catch (e) {}
};

export const framesListColumns = [
  {
    name: "frame_id",
    field: "frame_id",
    label: "ID",
    sortable: true,
    align: "center",
  },
  {
    name: "frame_type_name",
    field: "frame_type_name",
    label: "Тип",
    sortable: true,
    align: "center",
  },
  {
    name: "frame_name",
    field: "frame_name",
    label: "Наименование",
    sortable: true,
    align: "left",
  },
  {
    name: "frame_url",
    field: "frame_url",
    label: "Фото",
    sortable: true,
    align: "center",
  },
  {
    name: "edit",
    label: "Редактировать",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
  {
    name: "params",
    label: "Параметры",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];

export const frameParamsColumns = [
  {
    name: "frame_type_id",
    field: "frame_type_id",
    label: "ID",
    align: "center",
  },
  {
    name: "frame_param_type_name",
    field: "frame_param_type_name",
    label: "Параметр",
    align: "left",
  },
  {
    name: "param_value",
    field: "param_value",
    label: "Значение",
    align: "center",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
];
